import {
  CategoryPanelInput,
  CompendiumPanel,
  CompendiumTest,
  PackageCategoryPanel,
} from '@labsavvyapp/components'

export const generateCategoryPanelInput = (
  categories: PackageCategoryPanel[],
  defaultCategoryId: string,
): CategoryPanelInput[] => {
  if (!categories?.length) {
    return []
  }
  const categoryPanelInputs = categories.map((category) => ({
    category_id: category?.category?._id ?? defaultCategoryId,
    panels: generateCompendiumPanelInput(category?.panels),
  }))

  return categoryPanelInputs
}

const generateCompendiumPanelInput = (panels: CompendiumPanel[]) => {
  return panels.map((panel) => {
    const panelType = panel.tests.length > 1 ? 'group' : 'individual'
    return {
      type: panelType,
      tests: generateCompendiumPanelInputTests(panel.tests),
    }
  })
}

const generateCompendiumPanelInputTests = (tests: CompendiumTest[]): string[] => {
  if (tests[0]._id) {
    return tests.map((test) => {
      return test._id
    })
  } else {
    return tests as unknown as string[]
  }
}
